import { Injectable } from '@angular/core';
import { OAuthService } from "../o-auth/o-auth.service";
import { AngularFireDatabase } from "angularfire2/database";

import { Club } from "../../models/club";

@Injectable()
export class PaymentsService {
    club: Club;
    constructor(private database: AngularFireDatabase, private oAuthService: OAuthService) {
        this.club = oAuthService.getClub();
        //  console.log(this.club)
    }

    processPayment(token: any, amount: any, month: any) {
        console.log(token)
        const sub = {
            "cid": this.club.$key,
            "payment": {
                "paymentId": "",
                "paymentStatus": false
            },
            "month": month,
            "id": token.id,
            "card": {
                "exp_month": token.card.exp_month,
                "exp_year": token.card.exp_year,
                "last4": token.card.last4,
                "brand": token.card.brand,
                "country": token.card.country,
                "name": token.card.name
            },

            "amount": amount,
            "pay_date": new Date().getTime()
        }

        console.log(sub)
        this.database.database.ref(`/club-subscriptions/${this.club.$key}`).push(sub);

        return location.reload()
    }


}



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/services/payments/payments.service.ts